import { render, staticRenderFns } from "./Caption.vue?vue&type=template&id=2490ca86&scoped=true&"
import script from "./Caption.vue?vue&type=script&lang=ts&"
export * from "./Caption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2490ca86",
  null
  
)

export default component.exports